import type { Edge } from "@xyflow/react";
import { OVERLAY_Z } from "./graphLayout";

export const titleEdge = (source: string, target: string, id: string): Edge => ({
    id,
    source,
    target,
    type: "default",
    zIndex: OVERLAY_Z - 1,
    style: { stroke: "#9775fa", strokeWidth: 1.6 },
});

export const valueEdge = (source: string, target: string, id: string): Edge => ({
    id,
    source,
    target,
    type: "default",
    zIndex: OVERLAY_Z - 1,
    style: { stroke: "#d0bfff", strokeWidth: 1 },
});
